import React, {useState, Fragment, useEffect, useRef} from 'react';
import { Transition } from '@headlessui/react'
import Icon from '../Icons/Icon'
import AlertBadge from '../Icons/AlertBadge';

const Toast = ({toast}) => {
    const {type, title, message, persistent, clear} = toast;
    const count = toast.count.length;
    const [show, setShow] = useState(true);
    const closeAndClearTimeout = useRef({timeout: null});

    const closeAndClear = () => {
        setShow(false);
        setTimeout(clear, 500);
    }

    useEffect(() => {
        if (persistent) {
            return;
        }

        clearTimeout(closeAndClearTimeout?.current?.timeout);
        closeAndClearTimeout.current.timeout = setTimeout(closeAndClear, 5000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toast]);

    return <Transition
        show={show}
        as={Fragment}
        enter="transform ease-out duration-300 transition"
        enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enterTo="translate-y-0 opacity-100 sm:translate-x-0"
        leave="transition ease-in duration-100"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
    >
        <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-xl ring-1 ring-black ring-opacity-5"
            onClick={closeAndClear}
        >
            <div className="p-4">
                <div className="flex items-start">
                    <div className="shrink-0">
                        <AlertBadge size="small" theme={type} />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                        <p className="text-sm font-medium text-gray-900">
                            {title}
                            {count > 1 && <span className="ml-1 text-gray-400">(x {count})</span>}
                        </p>
                        <p className="mt-1 text-sm text-gray-500">{message}</p>
                    </div>
                    <div className="ml-4 flex shrink-0">
                        <button
                            type="button"
                            className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={closeAndClear}
                        >
                            <span className="sr-only">Close</span>
                            <Icon icon="XMark" size="2" aria-hidden="true" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Transition>;
}

export default Toast;
